import * as React from "react";
import { IconBase, IIconBase } from "src/icons/IconBase";

export const MachineryIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Machinery Main Components</title>
    <path d="M20 36h18v4H20zm20-16h4v14h-4zm-20-8h18v4H20zm-5-4h-3l-2 2H4v14h4v3h6v13h4V8h-3zm-5 11a3 3 0 113-3 3 3 0 01-3 3zm10 15h18V18H20zm10.4-14l-.56 5.71h2.8L27.6 32l.56-5.14h-2.8z" />
  </IconBase>
);
